const orgs_sort = (a,b,order,column_name,sorting_function_value) => {
	try {
		// Check if sorting_function_value(a)[column_name] exists before accessing properties
		const aObj = sorting_function_value(a);
		const bObj = sorting_function_value(b);
		
		// If column doesn't exist in either object, return 0 (no change in order)
		if (!aObj || !bObj || !aObj[column_name] || !bObj[column_name]) {
			console.warn(`Missing column "${column_name}" in sorting data`);
			return 0;
		}
		
		let value_a = aObj[column_name].value;
		let value_b = bObj[column_name].value;
		let field_type = aObj[column_name].field_type;
		
		if(field_type === 'number'){
			value_a = Number(value_a);
			value_b = Number(value_b);
		}

		if(field_type !== 'number'){
			if(!value_a) return 1*order;
			if(!value_b) return -1*order;
		}

		if(field_type === 'date'){
			return order*(new Date(value_b) - new Date(value_a));
		}
		
		if(value_a < value_b) return 1*order;
		return -1*order;
	} catch (error) {
		console.error("Error in sorting function:", error, "column:", column_name);
		return 0; // Return 0 to maintain sort order when there's an error
	}
}

const generic_sort_for_orgs = (column_name, stores, order, sorting_function_value) => {
	try {
		if (!stores || !Array.isArray(stores)) {
			console.warn("Invalid stores array in generic_sort_for_orgs");
			return [];
		}
		
		let all_stores = JSON.parse(JSON.stringify(stores));
		all_stores.sort((a,b) => orgs_sort(a,b,-1*order,column_name,sorting_function_value));
		return all_stores;
	} catch (error) {
		console.error("Error in generic_sort_for_orgs:", error);
		return stores || []; // Return original array if sorting fails
	}
}

export default generic_sort_for_orgs

